import React from "react";
import { Spinner } from "react-bootstrap";
import { BiAnalyse } from "react-icons/bi";

/**
 * ResultsLoadingModal Component
 * 
 * Loading indicator modal displayed while processing or generating analysis results.
 * Shows spinner with informational message indicating results are being computed.
 * Used within floating alerts when waiting for AI analysis or data processing to complete.
 * Provides visual feedback to user during async operations.
 * 
 * @returns {JSX.Element} Loading indicator with spinner and status message for results
 */
const ResultsLoadingModal = () => {
  return (
    <div style={{ display: "flex", paddingTop: "10px" }}>
      <div style={{ width: "90%" }}>
        <p style={{ color: "#0f9d58" }}>
          <BiAnalyse className="alert-icon" /> Loading
        </p>
        <p style={{ marginLeft: "28px" }}>
          We'll notify you once your results are ready.
        </p>
      </div>
      <div style={{ width: "10%", textAlign: "right" }}>
        <Spinner animation="border" variant="secondary" />
      </div>
    </div>
  );
};

export default ResultsLoadingModal;
